var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: 192,
    height: 192,
    viewBox: "0,0,256,256",
    style: {
      fill: "#000000"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 9,
    y1: 24,
    x2: 56.447,
    y2: 24,
    gradientUnits: "userSpaceOnUse",
    id: "color-1_34ekiFycLzXv_gr1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FFE72A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.781,
    stopColor: "#FFEE85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFF9F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: -8.783,
    y1: 24,
    x2: 31.217,
    y2: 24,
    gradientUnits: "userSpaceOnUse",
    id: "color-2_34ekiFycLzXv_gr2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FE4EFA",
    stopOpacity: 0.2
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE41DD",
    stopOpacity: 0.4
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 26.517,
    y1: 43.362,
    x2: 22.715,
    y2: 3.543,
    gradientUnits: "userSpaceOnUse",
    id: "color-3_34ekiFycLzXv_gr3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#DD71FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFFFF",
    stopOpacity: 0.2
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.998,40c-0.32,0 -0.645,-0.076 -0.946,-0.239l-26,-14c-0.648,-0.349 -1.052,-1.026 -1.052,-1.761c0,-0.735 0.404,-1.412 1.052,-1.761l26,-14c0.972,-0.525 2.186,-0.16 2.709,0.812c0.523,0.972 0.16,2.186 -0.812,2.709l-22.73,12.24l22.729,12.239c0.973,0.523 1.336,1.736 0.812,2.709c-0.361,0.671 -1.05,1.052 -1.762,1.052z",
    fill: "url(#color-1_34ekiFycLzXv_gr1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.998,40c0.712,0 1.401,-0.381 1.763,-1.052c0.523,-0.973 0.16,-2.186 -0.812,-2.709l-6.268,-3.375c-0.928,0.961 -1.597,2.171 -1.898,3.521l6.269,3.376c0.302,0.163 0.626,0.239 0.946,0.239z",
    fill: "#F2BB20",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.998,40c0.712,0 1.401,-0.381 1.763,-1.052c0.523,-0.973 0.16,-2.186 -0.812,-2.709l-7.353,-3.959c-0.889,0.994 -1.548,2.193 -1.899,3.52l7.356,3.961c0.301,0.163 0.625,0.239 0.945,0.239z",
    fill: "#F2BB20",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.998,40c0.712,0 1.401,-0.381 1.763,-1.052c0.523,-0.973 0.16,-2.186 -0.812,-2.709l-6.991,-3.765c-0.901,0.984 -1.562,2.186 -1.899,3.52l6.994,3.766c0.301,0.164 0.625,0.24 0.945,0.24z",
    fill: "#F2BB20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,24c0,0.735 0.404,1.412 1.052,1.761l6.268,3.375c0.928,-0.961 1.597,-2.171 1.898,-3.521l-2.999,-1.615l2.999,-1.615c-0.301,-1.35 -0.97,-2.56 -1.898,-3.521l-6.268,3.375c-0.648,0.349 -1.052,1.026 -1.052,1.761z",
    fill: "#F2BB20",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,24c0,0.735 0.404,1.412 1.052,1.761l7.353,3.959c0.889,-0.994 1.548,-2.193 1.899,-3.52l-4.085,-2.2l4.086,-2.2c-0.352,-1.327 -1.01,-2.526 -1.899,-3.52l-7.353,3.959c-0.649,0.349 -1.053,1.026 -1.053,1.761z",
    fill: "#F2BB20",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,24c0,0.735 0.404,1.412 1.052,1.761l6.991,3.765c0.901,-0.985 1.562,-2.187 1.899,-3.521l-3.723,-2.005l3.723,-2.005c-0.337,-1.334 -0.998,-2.536 -1.899,-3.521l-6.991,3.765c-0.648,0.349 -1.052,1.026 -1.052,1.761z",
    fill: "#F2BB20",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,24c0,0.735 0.404,1.412 1.052,1.761l6.63,3.57c0.914,-0.973 1.579,-2.179 1.899,-3.521l-3.362,-1.81l3.361,-1.81c-0.32,-1.342 -0.985,-2.547 -1.899,-3.521l-6.63,3.57c-0.647,0.349 -1.051,1.026 -1.051,1.761z",
    fill: "#F2BB20",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.998,40c0.712,0 1.401,-0.381 1.763,-1.052c0.523,-0.973 0.16,-2.186 -0.812,-2.709l-6.63,-3.57c-0.914,0.973 -1.579,2.179 -1.899,3.521l6.632,3.571c0.302,0.163 0.626,0.239 0.946,0.239z",
    fill: "#F2BB20",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F2BB20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.998,7.999c0.712,0 1.401,0.381 1.763,1.052c0.523,0.973 0.16,2.186 -0.812,2.709l-6.268,3.375c-0.928,-0.961 -1.597,-2.171 -1.898,-3.521l6.269,-3.376c0.302,-0.163 0.626,-0.239 0.946,-0.239z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.998,7.999c0.712,0 1.401,0.381 1.763,1.052c0.523,0.973 0.16,2.186 -0.812,2.709l-7.353,3.959c-0.889,-0.994 -1.548,-2.193 -1.899,-3.52l7.356,-3.961c0.301,-0.163 0.625,-0.239 0.945,-0.239z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.998,7.999c0.712,0 1.401,0.381 1.763,1.052c0.523,0.973 0.16,2.186 -0.812,2.709l-6.991,3.765c-0.901,-0.984 -1.562,-2.186 -1.899,-3.52l6.994,-3.766c0.301,-0.164 0.625,-0.24 0.945,-0.24z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.998,7.999c0.712,0 1.401,0.381 1.763,1.052c0.523,0.973 0.16,2.186 -0.812,2.709l-6.63,3.57c-0.914,-0.973 -1.579,-2.179 -1.899,-3.521l6.632,-3.571c0.302,-0.163 0.626,-0.239 0.946,-0.239z",
    opacity: 0.3
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#FF842D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.696,26.421l5.664,3.05c1.453,-1.16 2.434,-2.884 2.608,-4.842l-1.167,-0.629l1.167,-0.629c-0.175,-1.958 -1.155,-3.682 -2.608,-4.842l-5.664,3.05c-1.926,1.036 -1.924,3.806 0,4.842z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.64,15.471l5.664,-3.05c3.202,-1.724 0.588,-6.57 -2.607,-4.842l-5.665,3.05c0.174,1.958 1.155,3.682 2.608,4.842z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.032,37.371l5.665,3.05c3.162,1.707 5.844,-3.101 2.607,-4.842l-5.664,-3.05c-1.453,1.16 -2.434,2.884 -2.608,4.842z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,38c0,0.071 0.009,0.141 0.011,0.211l5.33,2.87c4.021,2.171 7.435,-3.948 3.318,-6.163l-5.33,-2.87c-1.995,1.233 -3.329,3.434 -3.329,5.952z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,10c0,2.518 1.334,4.719 3.329,5.952l5.33,-2.87c4.072,-2.193 0.747,-8.362 -3.318,-6.163l-5.327,2.868c-0.002,0.071 -0.014,0.141 -0.014,0.213z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.341,27.082l5.331,2.87c1.994,-1.233 3.328,-3.434 3.328,-5.952c0,-2.518 -1.334,-4.719 -3.329,-5.952l-5.331,2.87c-2.452,1.32 -2.447,4.845 0.001,6.164z",
    opacity: 0.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,38c0,0.378 0.038,0.747 0.096,1.109l4.889,2.633c4.881,2.634 9.026,-4.795 4.029,-7.484l-4.892,-2.634c-2.429,1.098 -4.122,3.537 -4.122,6.376z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,10c0,2.839 1.693,5.278 4.122,6.376l4.892,-2.634c4.942,-2.662 0.906,-10.153 -4.029,-7.484l-4.888,2.632c-0.058,0.362 -0.097,0.731 -0.097,1.11z",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.985,27.742l4.892,2.634c2.43,-1.098 4.123,-3.537 4.123,-6.376c0,-2.839 -1.693,-5.278 -4.122,-6.376l-4.892,2.634c-2.981,1.603 -2.972,5.883 -0.001,7.484z",
    opacity: 0.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30,38c0,0.724 0.11,1.422 0.314,2.078l4.316,2.324c5.741,3.097 10.617,-5.643 4.74,-8.805l-4.308,-2.32c-2.922,0.842 -5.062,3.53 -5.062,6.723z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30,10c0,3.193 2.14,5.881 5.062,6.722l4.308,-2.32c5.812,-3.131 1.064,-11.944 -4.74,-8.805l-4.299,2.315c-0.208,0.661 -0.331,1.359 -0.331,2.088z",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63,28.402l4.308,2.32c2.922,-0.841 5.062,-3.529 5.062,-6.722c0,-3.193 -2.14,-5.881 -5.062,-6.722l-4.308,2.32c-3.507,1.886 -3.495,6.921 0,8.804z",
    opacity: 0.1
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M44,10c0,3.866 -3.134,7 -7,7c-3.866,0 -7,-3.134 -7,-7c0,-3.866 3.134,-7 7,-7c3.866,0 7,3.134 7,7zM37,31c-3.866,0 -7,3.134 -7,7c0,3.866 3.134,7 7,7c3.866,0 7,-3.134 7,-7c0,-3.866 -3.134,-7 -7,-7zM11,17c-3.866,0 -7,3.134 -7,7c0,3.866 3.134,7 7,7c3.866,0 7,-3.134 7,-7c0,-3.866 -3.134,-7 -7,-7z",
    fill: "url(#color-2_34ekiFycLzXv_gr2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,3.5c3.584,0 6.5,2.916 6.5,6.5c0,3.584 -2.916,6.5 -6.5,6.5c-3.584,0 -6.5,-2.916 -6.5,-6.5c0,-3.584 2.916,-6.5 6.5,-6.5M11,17.5c3.584,0 6.5,2.916 6.5,6.5c0,3.584 -2.916,6.5 -6.5,6.5c-3.584,0 -6.5,-2.916 -6.5,-6.5c0,-3.584 2.916,-6.5 6.5,-6.5M37,31.5c3.584,0 6.5,2.916 6.5,6.5c0,3.584 -2.916,6.5 -6.5,6.5c-3.584,0 -6.5,-2.916 -6.5,-6.5c0,-3.584 2.916,-6.5 6.5,-6.5M37,3c-3.866,0 -7,3.134 -7,7c0,3.866 3.134,7 7,7c3.866,0 7,-3.134 7,-7c0,-3.866 -3.134,-7 -7,-7zM11,17c-3.866,0 -7,3.134 -7,7c0,3.866 3.134,7 7,7c3.866,0 7,-3.134 7,-7c0,-3.866 -3.134,-7 -7,-7zM37,31c-3.866,0 -7,3.134 -7,7c0,3.866 3.134,7 7,7c3.866,0 7,-3.134 7,-7c0,-3.866 -3.134,-7 -7,-7z",
    fill: "url(#color-3_34ekiFycLzXv_gr3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.a72cc0fa629a9a2f6e246e2218fad259.svg";
export { ForwardRef as ReactComponent };